import { Injectable, Injector, inject } from '@angular/core';
import { TuiDialogService, TuiDialogSize } from '@taiga-ui/core';
import { PolymorpheusComponent } from '@taiga-ui/polymorpheus';

import { InputDataType } from '../types';
import { ChatEditFormComponent } from '../chat-edit-form.component';

@Injectable({
  providedIn: 'root',
})
export class EditDialogService {
  private readonly dialogService = inject(TuiDialogService);
  private readonly injector = inject(Injector);

  open(label: string, data?: InputDataType, size: TuiDialogSize = 's', closeable = false, dismissible = false) {
    return this.dialogService.open<InputDataType>(new PolymorpheusComponent(ChatEditFormComponent, this.injector), {
      label,
      data,
      size,
      closeable,
      dismissible,
    });
  }
}
